var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.screenType === 'desktop')?_c('my-courses-sessions-desktop'):_c('my-courses-sessions-mobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }